module.exports = __webpack_public_path__ + "static/media/g&d.f72487b2.jpg";